import React from 'react';
import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';

import HorizontalIconCard from '../member/HorizontalIconCard';
import PoweredByFN from '../member/PoweredByFN';

const useStyles = makeStyles({
	root: {
		maxWidth: '100%',
		marginTop: 20,
		paddingLeft: 20,
		paddingRight: 20,
		border: '1px solid #C8CCD1'
	},
	cardTitleText: {
		marginTop: 30,
		marginBottom: 20,
		color: '#333333',
		fontFamily: 'Graphik',
		fontSize: 24,
		fontWeight: 600,
		letterSpacing: 0
	},
	gridList: {
		flexWrap: 'nowrap',
		// Promote the list into his own layer on Chrome. This cost memory but helps keeping high FPS.
		transform: 'translateZ(0)',
	},
	row: {
		marginBottom: 10
	}
});

function getCommitteeTitle(committeeAssignment) {
	if (undefined === committeeAssignment || undefined === committeeAssignment.committee || 
		undefined === committeeAssignment.committee.commonName) {
		return "";
	} else {
		return committeeAssignment.committee.commonName;
	}
}

function getSubCommitteeTitles(committeeAssignment) {
	if (undefined === committeeAssignment
		|| undefined === committeeAssignment.subcommitteeAssignments) {
		return "";
	} else {
		let titles = "";
		let subcomittees = committeeAssignment.subcommitteeAssignments;
		let arrayLength = subcomittees.length;
		subcomittees.forEach((subcommittee, index) => {
			if (subcommittee.committee) {
				titles += subcommittee.committee.commonName;
				if (index < arrayLength) {
					titles += ", ";
				}
			};
		});

		if (getCommitteeTitle(committeeAssignment).length <= 28) {
			return titles.substring(0, 70);
		} else {
			return titles.substring(0, 35);
		}
	}

}

function getCommitteeAssignments(member) {
	if (undefined === member.committeeAssignments) {
		return [];
	} else {
		return member.committeeAssignments;
	}
}

const MemberCommitteeAssgignmentsCard = ( member ) => {
	const classes = useStyles();

	if (undefined === member || undefined === member.committeeAssignments || !member.committeeAssignments.length) {
    	return null;
	}

	return (
		<Card className={classes.root} variant="outlined">
			<div className={classes.cardTitleText}>
				Committee Assignments
			</div>
			<Grid container spacing={3} className={classes.row} alignItems="stretch">
				{getCommitteeAssignments(member).map((committeeAssignment) => (
					<Grid key={committeeAssignment.committee.id} item xs={12} sm={12} md={6} lg={4} style={{display: 'flex', width: '100%'}}>
						<HorizontalIconCard
								title={getCommitteeTitle(committeeAssignment)}
								values={[getSubCommitteeTitles(committeeAssignment)]} />
					</Grid>
					))
				}	
			</Grid>
			<PoweredByFN />
		</Card>
	);
}

export default MemberCommitteeAssgignmentsCard;
